/**
 * Shared Recharts styling — one source of truth for series colors and chart
 * chrome. Series semantics are product truth: WMP blue = current year, amber
 * dashed = budget, slate = prior year, green/amber/red = performance.
 */

export const SERIES = {
  primary: "#4A7FB5", // WMP blue — current year / main series
  primarySoft: "#C9DBEC", // wmp-200 — light companion for the primary
  priorYear: "#CBD5E1", // prior-year bars
  priorYearLine: "#9ca3af", // prior-year dotted lines
  budget: "#f59e0b", // budget reference (always dashed)
  inventory: "#0d9488", // inventory teal
  positive: "#2DA770",
  warning: "#f59e0b",
  negative: "#EF4444",
  neutral: "#6b7280",
} as const;

export const GRID = {
  stroke: "#EEF1F5",
  strokeDasharray: "3 3",
} as const;

export const AXIS_TICK = { fontSize: 11, fill: "#6b7280" } as const;

/** contentStyle for default Recharts <Tooltip> instances */
export const TOOLTIP_STYLE = {
  backgroundColor: "#ffffff",
  border: "1px solid rgba(16, 29, 51, 0.08)",
  borderRadius: 10,
  boxShadow:
    "0 4px 8px rgba(16, 29, 51, 0.06), 0 12px 32px rgba(16, 29, 51, 0.10)",
  fontSize: 12,
} as const;

/**
 * Performance color matching server logic in performance.ts.
 * FinancialTable variant: ≥100 green, ≥95 amber, else red. (The portfolio
 * Dashboard's PacingDot intentionally uses ≥100/≥90 and stays local.)
 */
export function performanceColor(
  percentage: number,
  hasBudget: boolean,
): string {
  if (!hasBudget) return SERIES.neutral;
  if (percentage >= 100) return SERIES.positive;
  if (percentage >= 95) return SERIES.warning;
  return SERIES.negative;
}
